import {BookingEntityStorage} from "../storage/booking-entity-storage";
import {InfantPassengerModel} from "./infant-passenger.model";
import {InfantSessionStorageKeys} from "./infant-session-storage-keys";
import {BookingSessionStorageKeys} from "../storage/booking-session-storage-keys";

export class InfantSessionStorage extends BookingEntityStorage<InfantSessionStorageKeys> {
    constructor(infant: InfantPassengerModel) {
        super({
            parentStorage: infant.parent.booking.storage,
            parentStorageKey: BookingSessionStorageKeys.infantStorage,
            getStorageDiscriminator: () => `PassengerInfant_${infant.parent.passengerIndex}`
        })
    }

}
